"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = require("../../../BaseComponent");
var HegydCore_1 = require("../hegyd-core/HegydCore");
var $ = require("jquery");
var ProductCard = /** @class */ (function (_super) {
    __extends(ProductCard, _super);
    function ProductCard($view) {
        var _this = _super.call(this, $view) || this;
        _this.bind();
        _this.modal = null;
        return _this;
    }
    ProductCard.prototype.bind = function () {
        this.initEvents();
    };
    ProductCard.prototype.getSelectorLinkFavorite = function () {
        return 'a.add-fav';
    };
    ProductCard.prototype.getSelectorProductCart = function () {
        return '.product-item';
    };
    ProductCard.prototype.getSelectorAddCartCard = function () {
        return '.txt-product .btn-add-cart';
    };
    ProductCard.prototype.getSelectorDecli = function () {
        return 'select#variant-select';
    };
    ProductCard.prototype.getSelectorAddCart = function () {
        return '.modal .btn-add-cart';
    };
    ProductCard.prototype.getElementLinkFavorite = function () {
        return $(this.getSelectorLinkFavorite());
    };
    ProductCard.prototype.getUrlProductInfo = function () {
        return $('#add-cartModal').data('route_product_info');
    };
    ProductCard.prototype.onWishList = function () {
        return window.location.pathname === "/favoris";
    };
    ProductCard.prototype.toggleFavoris = function ($element) {
        var _this = this;
        HegydCore_1.default.sendRequest($element.attr('href'), 'PUT', {}, function (data) {
            // @ts-ignore
            Kernel.factories.Toaster($('html'), 'success', data.message);
            if (_this.onWishList()) {
                _this.$view.fadeOut();
            }
            else {
                $element.find('.in-fav').toggle();
                $element.find('.out-fav').toggle();
            }
        });
    };
    ProductCard.prototype.initEvents = function () {
        var _this = this;
        this.$view.on('click', this.getSelectorAddCartCard(), function (e) {
            HegydCore_1.default.initRemoteModal('#modal_product_item', $(e.target).data('route'), function () {
                // @ts-ignore
                Kernel.factories.ProductCardModal($('#modal_product_item'));
            });
        });
        //Click sur le boutton d'ajout aux favoris
        this.$view.find(this.getSelectorLinkFavorite()).off('click');
        this.$view.find(this.getSelectorLinkFavorite()).on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.toggleFavoris($(e.target).closest(_this.getSelectorLinkFavorite()));
        });
    };
    return ProductCard;
}(BaseComponent_1.default));
exports.default = ProductCard;
;
